import { useNavigate } from 'react-router-dom';
import styles from './asset/scoreSummary.module.scss';

const ScoreSummary = ({ totalAttempted = 0, overallAccuracy = 0, isLoading = false }) => {
    const navigate = useNavigate();

    if (isLoading) {
        return (
            <div className={styles.summaryContainer}>
                <div className={styles.summaryCard}>
                    <div className={styles.loadingSkeleton}>
                        <div className={styles.skeletonPulse} style={{ height: '24px', width: '50%', marginBottom: '20px' }} />
                        <div className={styles.skeletonPulse} style={{ height: '160px', width: '160px', borderRadius: '50%', margin: '0 auto 20px' }} />
                        <div className={styles.skeletonPulse} style={{ height: '60px', width: '100%' }} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.summaryContainer}>
            <div className={styles.summaryCard}>
                <h3 className={styles.summaryTitle}>Practice Summary</h3>

                <div className={styles.accuracyDisplay}>
                    <div className={styles.accuracyCircle}>
                        <svg className={styles.progressRing} width="160" height="160">
                            <circle
                                className={styles.progressRingCircle}
                                stroke="#e6e8ec"
                                strokeWidth="12"
                                fill="transparent"
                                r="70"
                                cx="80"
                                cy="80"
                            />
                            <circle
                                className={styles.progressRingCircleActive}
                                stroke="#220ec9"
                                strokeWidth="12"
                                fill="transparent"
                                r="70"
                                cx="80"
                                cy="80"
                                style={{
                                    strokeDasharray: `${2 * Math.PI * 70}`,
                                    strokeDashoffset: `${2 * Math.PI * 70 * (1 - overallAccuracy / 100)}`
                                }}
                            />
                        </svg>
                        <div className={styles.accuracyContent}>
                            <div className={styles.accuracyValue}>{overallAccuracy}%</div>
                            <div className={styles.accuracyLabel}>Accuracy</div>
                        </div>
                    </div>
                </div>

                <div className={styles.statsGrid}>
                    <div className={styles.statItem}>
                        <div className={styles.statLabel}>Total Questions</div>
                        <div className={styles.statValue}>{totalAttempted}</div>
                    </div>
                    <div className={styles.statDivider}></div>
                    <div className={styles.statItem}>
                        <div className={styles.statLabel}>Overall Accuracy</div>
                        <div className={styles.statValue}>{overallAccuracy}%</div>
                    </div>
                </div>

                <button
                    className={styles.improveButton}
                    onClick={() => navigate('/user-sat-practice')}
                >
                    Start Practicing
                </button>
            </div>
        </div>
    );
};

export default ScoreSummary;
